"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OidcSessionStorage_1 = require("./OidcSessionStorage");
var OidcAccessToken_1 = require("./OidcAccessToken");
var OidcIdToken_1 = require("./OidcIdToken");
var OidcUrlHelper = /** @class */ (function () {
    function OidcUrlHelper() {
        var _this = this;
        this.ACCESS_TOKEN = 'access_token';
        this.ID_TOKEN = 'id_token';
        this.storage = new OidcSessionStorage_1.OidcSessionStorage();
        this.storeTokenFromParams = function (params) {
            _this.validateParams(params);
            var oidcToken = new OidcAccessToken_1.OidcAccessToken(params.get(_this.ACCESS_TOKEN));
            _this.storage.storeAccessToken(oidcToken);
            var oidcIdToken = new OidcIdToken_1.OidcIdToken(params.get(_this.ID_TOKEN));
            _this.validateIdToken(oidcIdToken);
            _this.storage.storeIdToken(oidcIdToken);
            _this.storage.State.clear();
            _this.storage.Nonce.clear();
            var redirectUrl = params.get('redirectUrl');
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        };
        this.validateIdToken = function (token) {
            if (!token) {
                return;
            }
            if (token.getClaim('nonce') !== _this.storage.Nonce.get()) {
                throw new Error("Auth - incorrect nonce");
            }
        };
        this.validateParams = function (params) {
            if (params.get('error')) {
                throw new Error("Auth - " + params.get('error'));
            }
            if (params.get('state') !== _this.storage.State.get()) {
                throw new Error("Auth - incorrect state");
            }
            if (!params.get(_this.ACCESS_TOKEN)) {
                throw new Error("Auth - missing token");
            }
        };
    }
    return OidcUrlHelper;
}());
exports.OidcUrlHelper = OidcUrlHelper;
//# sourceMappingURL=OidcUrlHelper.js.map